// @flow

import * as React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import classnames from 'classnames';

import styles from './styles.scss';

import { setContactFormShowStatus } from '../../redux/actionsCreators';

import { servicesCategories } from '../../utils/variables';

import type { DefaultStateType } from '../../redux/reducers';
import type { CategoryType } from '../../api/types';

type Props = {
  history: Object,
  match: Object,
  category: CategoryType,
  type?: 'default' | 'subcategory',
  showContactForm: boolean,
  setContactFormShowStatus: (status: boolean) => void,
  onMouseEnter?: () => void,
  onMouseLeave?: () => void,
};

type State = {
  isHovered: boolean,
};

class Category extends React.Component<Props, State> {
  static defaultProps = {
    type: 'default',
    onMouseEnter: undefined,
    onMouseLeave: undefined,
  };

  state = {
    isHovered: false,
  };

  handleClick = () => {
    const { history, match, category, showContactForm, setContactFormShowStatus } = this.props;

    if (!servicesCategories.includes(category.name) && category.children.length === 0 && !showContactForm) {
      if (document && document.body) {
        document.body.classList.add('showContactForm');
      }

      return setContactFormShowStatus(true);
    }

    const formattedName = category.name.replace(/\s+/g, '-').toLowerCase();

    let link = formattedName;

    if (match.url !== '/categories') {
      link = `${match.url}/${formattedName}`;
    }

    return history.push(link);
  };

  onMouseEnter = () => this.setState({ isHovered: true }, () => this.props.onMouseEnter && this.props.onMouseEnter());

  onMouseLeave = () => this.setState({ isHovered: false }, () => this.props.onMouseLeave && this.props.onMouseLeave());

  render(): React.Node {
    const { category, type } = this.props;
    const { isHovered } = this.state;

    return (
      <div
        className={classnames(styles.item, 'card', { active: isHovered })}
        onClick={this.handleClick}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <figure>
          <div className={styles.borders}>
            <span className={styles.border} />
            <span className={styles.border} />
            <span className={styles.border} />
            <span className={styles.border} />
          </div>
          <p className="imageWrap" data-clear>
            <img src={category.image} alt={category.name} />
          </p>
          <figcaption>
            <span>{category.name}</span>
          </figcaption>
          <div className="sail" data-clear />
        </figure>
        {type !== 'subcategory' && (
          <div className="caption" data-clear>
            / {category.name}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: DefaultStateType): { showContactForm: boolean } => ({
  showContactForm: state.showContactForm,
});

const mapDispatchToProps = (dispatch: Function): Object => ({
  setContactFormShowStatus(status: boolean) {
    dispatch(setContactFormShowStatus(status));
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Category),
);



// WEBPACK FOOTER //
// ./src/components/Category/index.js